module.exports = __webpack_public_path__ + "af5fdae6dc00931a050af441e5858e20.MP3";